import React, { useContext, useEffect, useState, useRef } from "react";
import { Alert, Grid } from "@mui/material";
import { AuthContext } from "../AuthContext";
import ClaimsGrid from "./ClaimsGrid";
import {
  getClaimsList,
  rejectClaim,
  updateClaimFromSt,
  updateClaimId,
  claimsAdTools,
  updateClaimAgreementId,
} from "../services/ClaimsServices.js";
import {
  getAgreementsByDealerIdAndLocatonId,
} from "../services/dealerServices.js";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Button,
  CircularProgress,
  Typography, // Add this
  Box,
} from "@mui/material";
import JBWDateLabel from './JBWDateLabel';

const ClaimsList = ({
  dealer,
  showDealer = false,
  displayType,
  dealerId,
  filterAgreementId,
  tenant,
  businessUnits,
}) => {
  console.log("Claims List displayType : ", displayType);
  console.log(
    `Claim List displayType dealerid:${dealerId}, filteredAgreementId : ${filterAgreementId}`
  );
  const { user } = useContext(AuthContext);
  const [claimList, setClaimList] = useState([]);
  const [claimListLoading, setClaimListLoading] = useState(false);
  const [claimMessage, setClaimMessage] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [agreements, setAgreements] = useState([]);
  const [selectedClaim, setSelectedClaim] = useState(null);
  const [selectedAgreement, setSelectedAgreement] = useState(null);
  const [loadingAgreements, setLoadingAgreements] = useState(false);
  const hasLoaded = useRef(false);
  const loadClaimsList = (_dealerId) => {
    setClaimListLoading(true);
    getClaimsList(_dealerId)
      .then(
        (res) => {
          console.log("claims List Response :", res);
          const data = res.data;
          console.log("claims List :", data);
          const statusCode = res.status;
          if (statusCode === 200 && data && data.length > 0) {
            setClaimList(data);
          }
          setClaimListLoading(false);
        },
        (err) => {
          setClaimListLoading(false);
          console.log("Unable to load data from claims service", err);
        }
      )
      .catch((err) => {
        setClaimListLoading(false);
        console.error("Get Claims List Internal Server error", err);
      });
  };

  const selectedDealer = dealer;
  const disType = displayType;
  useEffect(() => {
    //const dealerId = selectedDealer ? selectedDealer.id : 0;
    if (disType === "admin") {
      console.log("loading agreement list from admin user");
      loadClaimsList(0);
    } else {
      console.log("display type :", disType);
      if (selectedDealer) {
        loadClaimsList(selectedDealer.dealerId);
      }
    }
  }, [selectedDealer, disType]);

  // 1. Define the missing function
  const refreshData = () => {
    const _dealerId = disType === "admin" ? 0 : (selectedDealer?.dealerId || 0);
    setClaimListLoading(true);

    getClaimsList(_dealerId)
      .then((res) => {
        if (res.status === 200 && res.data) {
          setClaimList(res.data);
        }
      })
      .catch((err) => console.error("Data Load Error:", err))
      .finally(() => setClaimListLoading(false));
  };

  useEffect(() => {
    if (hasLoaded.current) return;
    hasLoaded.current = true;

    refreshData();
  }, [selectedDealer, disType]);

  const handleVerifyClaim = (param) => {
    console.log("verifyClaim", param);
    setClaimMessage("Please wait while claim Verifing");
    updateClaimFromSt(param.jbwAgreementId, param.jbwClaimId)
      .then(
        (res) => {
          console.log("claims update Response :", res);
          const data = res.data;
          console.log("claims update :", data);
          const statusCode = res.status;
          if (statusCode === 200) {
            setClaimMessage("");
            refreshData();
            if (disType === "admin") {
              loadClaimsList(0);
            } else {
              if (selectedDealer) {
                loadClaimsList(selectedDealer.dealerId);
              }
            }
          }
        },
        (err) => {
          setClaimMessage("");
          console.log("Unable to load data from claims service", err);
          if (disType === "admin") {
            loadClaimsList(0);
          } else {
            if (selectedDealer) {
              loadClaimsList(selectedDealer.dealerId);
            }
          }
        }
      )
      .catch((err) => {
        setClaimMessage("");
        console.error("Get Claims List Internal Server error", err);
        if (disType === "admin") {
          loadClaimsList(0);
        } else {
          if (selectedDealer) {
            loadClaimsList(selectedDealer.dealerId);
          }
        }
      });
  };

  const handleRejectClaim = (param) => {
    let selectedIds = "";
    if (Array.isArray(param)) {
      selectedIds = param.map(cl => cl.id).join(",")
    } else {
      selectedIds = param.id;
    }
    console.log("RejectClaim", param);
    console.log("selected dealer :", selectedDealer);
    setClaimMessage("Please wait while claim rejecting");
    rejectClaim(0, user.name, selectedIds)
      .then(
        (res) => {
          console.log("claims Reject Response :", res);
          const data = res.data;
          console.log("claims Reject :", data);
          const statusCode = res.status;
          if (statusCode === 200) {
            setClaimMessage("");
            if (disType === "admin") {
              loadClaimsList(0);
            } else {
              if (selectedDealer) {
                loadClaimsList(selectedDealer.dealerId);
              }
            }
          }
        },
        (err) => {
          setClaimMessage("");
          console.log("Unable to load data from claims service", err);
          if (disType === "admin") {
            loadClaimsList(0);
          } else {
            if (selectedDealer) {
              loadClaimsList(selectedDealer.dealerId);
            }
          }
        }
      )
      .catch((err) => {
        setClaimMessage("");
        console.error("Get Claims List Internal Server error", err);
        if (disType === "admin") {
          loadClaimsList(0);
        } else {
          if (selectedDealer) {
            loadClaimsList(selectedDealer.dealerId);
          }
        }
      });
  };

  const handleAgreementUpdate = async () => {
    if (!selectedAgreement || !selectedClaim) return;

    setClaimMessage("Updating Agreement Link...");
    try {
      // PATCH Call: updateClaimAgreementId(id, isAgreementIdUpdate, agreementId)
      await updateClaimAgreementId(
        selectedClaim.id,               // The ID of the claim
        true,                           // isAgreementIdUpdate flag
        selectedAgreement.jbwAgreementId,// The new ID from the GET list
        selectedAgreement.productCode
      );

      setOpenDialog(false);
      setSelectedAgreement(null);
      refreshData(); // Refresh the grid to show the new ID
    } catch (err) {
      console.error("Failed to patch agreement:", err);
    } finally {
      setClaimMessage("");
    }
  };
  const handleEditAgreement = async (row) => {
    if (!row.dealerId || !row.locationId) {
      console.error("Missing Dealer or Location ID");
      return;
    }

    setSelectedClaim(row);
    setLoadingAgreements(true);
    setAgreements([]); // Clear previous data
    setOpenDialog(true);

    try {
      const res = await getAgreementsByDealerIdAndLocatonId(row.dealerId, row.locationId);

      // Check if the response is valid
      if (res && res.data) {
        setAgreements(res.data);
      } else {
        setAgreements([]);
      }
    } catch (err) {
      console.error("Error fetching agreements:", err);
      setAgreements([]);
    } finally {
      setLoadingAgreements(false);
    }
  };

  const handleUpdateClaim = (param) => {
    console.log("claim list update claim", param);
    if (param && param.claimid) {
      setClaimMessage("Please wait while updating the claim");
      updateClaimId(
        param.id,
        param.claimid,
        user.name,
        param.result,
        param.agreementid
      )
        .then(
          (res) => {
            console.log("claims id update Response :", res);
            const data = res.data;
            console.log("claims id update :", data);
            const statusCode = res.status;
            if (statusCode === 200) {
              setClaimMessage("");
              if (disType === "admin") {
                loadClaimsList(0);
              } else {
                if (selectedDealer) {
                  loadClaimsList(selectedDealer.dealerId);
                }
              }
            }
          },
          (err) => {
            setClaimMessage("");
            console.log("Unable to load data from claims service", err);
            if (disType === "admin") {
              loadClaimsList(0);
            } else {
              if (selectedDealer) {
                loadClaimsList(selectedDealer.dealerId);
              }
            }
          }
        )
        .catch((err) => {
          setClaimMessage("");
          console.error("Get Claims List Internal Server error", err);
          if (disType === "admin") {
            loadClaimsList(0);
          } else {
            if (selectedDealer) {
              loadClaimsList(selectedDealer.dealerId);
            }
          }
        });
    }
  };

  const handleReviveClaim = async (row) => {
    console.log("Revive claim called", row);
    try {
      const result = await claimsAdTools(row.id, "revive", user.name);
      console.log("Revive result:", result);
      if (disType === "admin") {
        loadClaimsList(0);
      } else if (selectedDealer) {
        loadClaimsList(selectedDealer.dealerId);
      }
    } catch (err) {
      console.error("Revive claim error:", err);
    }
  };

  const handleMultiRevive = async (selectedClaims) => {
    console.log("Reviving selected rows:", selectedClaims);

    if (!selectedClaims || selectedClaims.length === 0) return;

    try {
      setClaimMessage("Reviving selected claims...");

      await Promise.all(
        selectedClaims.map((row) =>
          claimsAdTools(row.id, "revive", user.name)
        )
      );

      //refresh only once
      refreshData();

    } catch (err) {
      console.error("Bulk revive error:", err);
    } finally {
      setClaimMessage("");
    }
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          {!claimMessage ? (
            <ClaimsGrid
              claimList={claimList}
              showDealer={showDealer}
              dealer={dealer}
              showLoading={claimListLoading}
              onVerifyClaim={handleVerifyClaim}
              onRejectClaim={handleRejectClaim}
              onReviveClaim={handleReviveClaim}
              onUpdateClaim={handleUpdateClaim}
              onEditAgreement={handleEditAgreement}
              tenant={tenant}
              businessUnits={businessUnits}
              handleMultiRevive={handleMultiRevive}
              onRefreshClaims={refreshData}
            />
          ) : (
            <Alert severity="info">{claimMessage}</Alert>
          )}
        </Grid>
      </Grid>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
        <DialogTitle>Select Agreement</DialogTitle>

        <DialogContent dividers>
          {loadingAgreements ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
              <CircularProgress size={30} />
            </Box>
          ) : agreements.length > 0 ? (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Agreement ID</TableCell>
                  <TableCell>Product Code</TableCell>
                  <TableCell>Expiration Date</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {agreements.map((ag, index) => {
                  const isSelected =
                    selectedAgreement?.jbwAgreementId === ag.jbwAgreementId;

                  return (
                    <TableRow
                      key={index}
                      hover
                      selected={isSelected}
                      onClick={() => setSelectedAgreement(ag)}
                      sx={{
                        cursor: "pointer",
                      }}
                    >
                      <TableCell>{ag.jbwAgreementId}</TableCell>
                      <TableCell>{ag.productCode}</TableCell>
                      <TableCell>{ag.expirationDate && <JBWDateLabel inputDate={ag.expirationDate} dateFormat="MM/DD/YYYY" />}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          ) : (
            <Box sx={{ p: 3, textAlign: "center" }}>
              <Typography color="textSecondary">
                No agreements found for this location.
              </Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>

          <Button
            variant="contained"
            onClick={handleAgreementUpdate}
            disabled={!selectedAgreement || loadingAgreements} // same logic
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>

  );
};

export default ClaimsList;
